<template>
  <el-card
    class="detail"
    v-loading="!isLoadForm"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="title">二级信息</div>
    <FormData
      ref="fistFormRef"
      :formData="formData"
      :isReadonly="!isUpdateStatus"
      v-if="isLoadForm"
    />

    <template v-if="status !== 'create'">
      <div class="title">下级信息</div>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="partnersBanks"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @cell-dblclick="dblclickEvent"
        @cell-click="cellClick"
      >
        <template v-slot:buttons v-if="isUpdateStatus">
          <el-button @click="addNewStoreHandler" type="primary" class="vxe-btn-primary"
            >新建</el-button
          >
          <el-button @click="deleteBtnClickHandler" type="danger" class="vxe-btn-delete"
            >删除</el-button
          >
          <el-button @click="batchGenerateBtnClickHandler" type="primary" class="vxe-btn-delete"
            >批量生成</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column field="storageCode" title="三级编码"></vxe-table-column>
        <vxe-table-column field="storageName" title="三级名称"> </vxe-table-column>
        <vxe-table-column field="storageCompanyName" title="所属组织"> </vxe-table-column>
        <vxe-table-column field="belongToLevel1Name" title="所属一级"> </vxe-table-column>
        <vxe-table-column field="belongToLevel2Name" title="所属二级"> </vxe-table-column>
        <vxe-table-column field="storageCreatePersonName" title="创建人"> </vxe-table-column>
        <vxe-table-column field="storageCreateTime" title="创建时间">
          <template v-slot="{ row }">
            {{ formatDateToString(row.storageCreateTime) }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="currentStatus" title="状态">
          <template v-slot="{ row }">
            <span>{{ getCurrentStatus(row.currentStatus) }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="multipleSelection"
        @changePageHandler="changePageHandler"
      />
    </template>

    <div class="foot-btn-group">
      <template v-if="status == 'create'">
        <el-button type="primary" @click="saveBtnClickHandler">保存 </el-button>
        <el-button type="primary" @click="submitBtnClickHandler('create')">提交</el-button>
      </template>

      <template v-else>
        <el-button v-if="!isUpdateStatus" type="primary" @click="isUpdateStatus = true"
          >修改</el-button
        >
        <el-button v-if="isUpdateStatus" type="primary" @click="isUpdateStatus = false"
          >详情</el-button
        >
        <el-button type="primary" @click="submitBtnClickHandler('submit')">提交</el-button>
      </template>
      <el-button type="info" @click="backBtnClickHandler">返回</el-button>
    </div>
    <!-- 批量弹框 -->
    <BatchGenerateDialog ref="batchGenerateDialogRef" @storeDataInfo="storeDataInfoHandler" />
    <!-- 新增二级仓库 -->
    <AddStoreDialog
      ref="addStoreDialogRef"
      :isEdit="cellClickRowIndex != -1"
      :default-value="cellClickRowName"
      @newStoreHandler="newStoreHandler"
      @edit="editCellName"
    ></AddStoreDialog>
  </el-card>
</template>

<script>
  import { mapState } from 'vuex';
  import storeMasterAPI from '@/api/storeMasterData';
  import FormData from './components/FormData';
  import BatchGenerateDialog from './components/BatchGenerateDialog';

  import AddStoreDialog from './components/AddStoreDialog';
  import storeMixin from './../../storeMixin.js';
  export default {
    name: 'Detail',
    mixins: [storeMixin],
    data() {
      return {
        tableData: [],
        status: 'create',
        batchGenerateData: {},
        requestByList: [],
        isUpdateStatus: false,
        formData: {},
        storageName: '',
        isLoadForm: false,
        currentDate: new Date(),
        tableTotal: 0,
        multipleSelection: [],
        belongToLevel1Id: '',
        belongToLevel1Name: '',
        belongToLevel2Id: '',
        belongToLevel2Name: '',
        cellClickRowIndex: -1,
        cellClickRowName: '',
      };
    },
    methods: {
      cellClick({ row, columnIndex, rowIndex }) {
        if (row.storageCode || columnIndex !== 2) return;
        this.cellClickRowIndex = rowIndex;
        this.cellClickRowName = row.storageName;
        this.$refs.addStoreDialogRef.openModal();
      },
      editCellName(form) {
        this.$set(this.tableData[this.cellClickRowIndex], 'storageName', form.storageName);
        this.cellClickRowIndex = -1;
        this.cellClickRowName = '';
      },
      deleteBtnClickHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const isDeleteFlag = selectedList.some((item) => item.id);
        if (isDeleteFlag) {
          this.$message.error('选中的包括了不能删除的数据');
          return;
        }
        // this.tableData.splice()
        // 过滤当前选中的数据
        const selectedStorageName = selectedList.map((item) => item.storageName);
        this.tableData = this.tableData.filter(
          (item) => !selectedStorageName.includes(item.storageName)
        );
      },
      // 批量生成
      batchGenerateBtnClickHandler() {
        this.$refs.batchGenerateDialogRef.openModal(this.storageName);
      },
      // 保存按钮
      saveBtnClickHandler() {
        this.$refs.fistFormRef.validate((formData) => {
          this._postData('save', 'ZT01', 2, formData, [], {
            belongToLevel1Name: this.belongToLevel1Name,
            belongToLevel1Id: this.belongToLevel1Id,
            belongToLevel2Id: this.belongToLevel2Id,
            belongToLevel2Name: this.belongToLevel2Name,
          });
        });
      },
      // 提交按钮
      submitBtnClickHandler(type) {
        let tableData = [];
        if (this.status !== 'create') {
          tableData = this.$refs.partnersBanks.getTableData().fullData;
        }
        this.$refs.fistFormRef.validate((formData) => {
          this._postData(type, 'ZT02', 2, formData, tableData, {
            belongToLevel1Name: this.belongToLevel1Name,
            belongToLevel1Id: this.belongToLevel1Id,
            belongToLevel2Id: this.belongToLevel2Id,
            belongToLevel2Name: this.belongToLevel2Name,
          });
        });
      },

      // 新增按钮
      addNewStoreHandler() {
        this.$refs.addStoreDialogRef.openModal();
      },
      newStoreHandler(dataInfo) {
        this.tableData.push({
          storageName: dataInfo.storageName,
          storageCreatePersonNo: this.userInfo.userCode,
          storageCreatePersonName: this.userInfo.personName,
          storageCompanyCode: this.formData.storageCompanyCode,
          storageCompanyName: this.formData.storageCompanyName,
          isReality: this.formData.isReality,
          companyName: this.userInfo.companyName,
          companyCode: this.userInfo.companyCode,
          storageCreateTime: new Date(),
          personInCharge: this.formData.personInCharge,
          personInChargeCode: this.formData.personInChargeCode,
          contactPerson: this.formData.contactPerson,
          contactTelephone: this.formData.contactTelephone,
          isSpecial: this.formData.isSpecial,
          storageType: this.formData.storageType,
          provinceCode: this.formData.provinceCode,
          cityCode: this.formData.cityCode,
          storageAddress: this.formData.storageAddress,
          belongToLevel1Name: this.formData.belongToLevel1Name,
          belongToLevel1Id: this.formData.belongToLevel1Id,
          belongToLevel2Name: this.formData.storageName,
          belongToLevel2Id: this.formData.storageCode,
          storageVariety: this.formData.storageVariety,
        });
      },
      // 获取下一级仓库数据
      async getSubPageApi(pageNum = 1, pageSize = 10) {
        const postData = {
          data: {
            id: +this.$route.query?.rowId,
            nextLevel: 3,
          },
          pageNum,
          pageSize,
        };
        const { data } = await this.$axios.post(storeMasterAPI.GET_SUB_STORAGE, postData);
        if (data.code === 0) {
          this.tableData = data.data.records;
          this.tableTotal = data.data.total;
        }
      },
      // 根据id获取数据反填到表单上
      async getFormDataApi(id) {
        const { data } = await this.$axios.get(`${storeMasterAPI.GET_FORM_DATA_BY_ID}/${id}`);
        this.getSubPageApi(1, 10);
        if (data.code == 0) {
          this.formData = data.data;
          this.storageName = data.data.storageName;
          this.belongToLevel1Id = data.data.belongToLevel1Id;
          this.belongToLevel1Name = data.data.belongToLevel1Name;
          this.belongToLevel2Id = data.data.id;
          this.belongToLevel2Name = data.data.storageName;
          this.isLoadForm = true;
        } else {
          console.error('根据id获取表单数据失败');
        }
      },
      // 批量生成
      storeDataInfoHandler(dataInfo) {
        console.log(dataInfo, '---111-');
        const { prefix, startNum, endNum, storageVariety } = dataInfo;
        console.log(storageVariety);
        for (let i = +startNum; i <= +endNum; i++) {
          this.tableData.push({
            storageName: `${prefix}_${i}`,
            storageCreatePersonNo: this.userInfo.userCode,
            storageCreatePersonName: this.userInfo.personName,
            storageCompanyCode: this.formData.storageCompanyCode,
            storageCompanyName: this.formData.storageCompanyName,
            isReality: this.formData.isReality,
            companyName: this.userInfo.companyName,
            companyCode: this.userInfo.companyCode,
            storageCreateTime: new Date(),
            storageVariety: storageVariety.join(','),
            personInCharge: this.formData.personInCharge,
            personInChargeCode: this.formData.personInChargeCode,
            contactPerson: this.formData.contactPerson,
            contactTelephone: this.formData.contactTelephone,
            isSpecial: this.formData.isSpecial,
            storageType: this.formData.storageType,
            provinceCode: this.formData.provinceCode,
            cityCode: this.formData.cityCode,
            storageAddress: this.formData.storageAddress,
            belongToLevel1Name: this.formData.belongToLevel1Name,
            belongToLevel1Id: this.formData.belongToLevel1Id,
            belongToLevel2Name: this.formData.storageName,
            belongToLevel2Id: this.formData.storageCode,
          });
        }
      },
      // 返回
      backBtnClickHandler() {
        this.$router.go(-1);
      },
      // 表格中选择
      handleSelectionChange(ev) {
        this.multipleSelection = ev.selection;
      },
      // 双击行
      dblclickEvent(value) {
        this._dblclickEvent(value.row.id, 'threeLevelDetail');
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      storageCreatePersonName() {
        return this.userInfo.personName;
      },
      storageCreatePersonNo() {
        return this.userInfo.userCode;
      },
    },
    mounted() {
      this.status = this.$route.query?.status;
      if (this.$route.query?.rowId) {
        this.getFormDataApi(this.$route.query?.rowId);
      }
      if (this.$route.query?.status === 'create') {
        this.isLoadForm = true;
      }
    },
    components: {
      FormData,
      BatchGenerateDialog,
      AddStoreDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .detail {
    background: #fff;
    border-radius: 8px;
    .title {
      font-size: 18px;
      padding: 10px;
      padding-left: 20px;
      font-weight: 700;
    }
    .foot-btn-group {
      margin-top: 30px;
    }
  }
</style>
